import React, {PureComponent} from 'react';
import {pushEdapEvent} from '../../utils/edap';
import {addListener, removeAllListeners} from '../../utils/scroll';
import EdapViewTracker from '../common/edap-view-tracker/EdapViewTracker';
import './arrow-mobile.svg';
import './arrow-desktop.svg';
import {selector} from '../../utils/wdio-selectors';

const ACTION_LOCATION = 'back-to-top';

export class ScrollToTopButtonComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            displayBackToTopButton: false,
            scrollingInterval: 0,
        };
    }

    componentDidMount() {
        const jumbotronHeight = document.querySelector('.jumbotron')
            .clientHeight;

        addListener(this.scrollHandler.bind(this, jumbotronHeight));
    }

    componentWillUnmount() {
        removeAllListeners();
    }

    scrollAnimation(distance) {
        if (window.pageYOffset === 0) {
            clearInterval(this.state.scrollingInterval);
        }

        scrollBy(0, -distance);
    }

    scrollToTop = () => {
        const ANIMATION_TIME = 600;
        const INTERVAL_TIME = 10;
        const MINIMUM_DISTANCE = 90;
        const distancePerInterval = Math.max(
            window.pageYOffset / (ANIMATION_TIME / INTERVAL_TIME),
            MINIMUM_DISTANCE
        );

        let scrollingInterval = setInterval(
            this.scrollAnimation.bind(this, distancePerInterval),
            INTERVAL_TIME
        );

        this.setState({scrollingInterval});

        pushEdapEvent('generic.event', {
            actionlocation: ACTION_LOCATION,
            eventcategory: 'back-to-top',
            eventaction: 'button-clicked',
        });
        pushEdapEvent('cta.selected', {
            action_location: ACTION_LOCATION,
            event_category: 'back-to-top',
            event_action: 'button-clicked',
        });
    };

    scrollHandler = (jumbotronTop) => {
        this.setState({
            displayBackToTopButton: window.pageYOffset > jumbotronTop,
        });
    };

    render() {
        const {translation} = this.props;
        const button = (
            <>
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'top',
                    }}
                    edapEvent={'content_module.presented'}
                />
                <button
                    aria-label={translation}
                    onClick={this.scrollToTop}
                    className="scroll-to-top btn btn-primary"
                    data-wdio={selector.backToTop}
                >
                    <span>{translation}</span>
                </button>
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'bottom',
                    }}
                    edapEvent={'content_module.presented'}
                />
                <EdapViewTracker
                    eventData={{
                        actionlocation: ACTION_LOCATION,
                    }}
                />
            </>
        );

        return translation && this.state.displayBackToTopButton ? button : null;
    }
}

export default ScrollToTopButtonComponent;
